import { render, staticRenderFns } from "./ReviewTempTable.vue?vue&type=template&id=a35badaa&scoped=true&"
import script from "./ReviewTempTable.vue?vue&type=script&lang=js&"
export * from "./ReviewTempTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35badaa",
  null
  
)

export default component.exports